import { render, staticRenderFns } from "./CasesView.vue?vue&type=template&id=7edaf843"
import script from "./CasesView.vue?vue&type=script&lang=js"
export * from "./CasesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports